/* GetRemixCover.js */
/* @author: anghello */

const COVER_IMG = process.env.REACT_APP_COVER_IMG_LOCATION;

module.exports.getRemixCover = (remix) => {
  let remixCover = COVER_IMG;
  if (remix) {
    if (remix.rid) { remixCover = remixCover.replace('{id}', remix.rid); }
    if (remix.rmdate) { remixCover = `${remixCover}?rmdate=${remix.rmdate}`; }
  }
  return remixCover;
}
